import { gettext } from './../gettext-extract-util';

export const ROOT_TABLE_COLUMNS_STATE = 'tableColumns';

export const INITIAL_STATE = {
  columns: {
    security_groups: {
      key: 'security:group:',
      label: gettext('Security Groups'),
      visible: true,
      orderable: false,
      type: 'list',
      options: [],
      parent: 'properties',
    },
    account: {
      key: 'accountId',
      label: gettext('Account'),
      visible: true,
      parent: 'account',
      orderable: false,
      type: 'text',
    },
    transferrable: {
      key: 'transferrable',
      label: gettext('Transferrable'),
      visible: true,
      parent: 'transferrable',
      type: 'boolean',
    },
    last_communicated: {
      key: 'communicatedAt',
      label: gettext('Last Communicated'),
      visible: true,
      orderable: true,
      sort_key: 'communicatedAt',
      type: 'timeago',
    },
    activated_date: {
      key: 'createdAt',
      label: gettext('Activated Date'),
      visible: true,
      orderable: true,
      sort_key: 'createdAt',
      type: 'date',
    },
    last_seen: {
      key: 'coordsAt',
      label: gettext('Last Seen'),
      visible: true,
      orderable: true,
      sort_key: 'coordsAt',
      type: 'timeago',
    },
    bluetooth: {
      key: 'networkTechnology',
      label: gettext('Bluetooth'),
      visible: true,
      parent: 'bluetooth',
      type: 'bluetooth',
    },
    device_id: {
      key: 'onei3:serial',
      label: gettext('Device Serial Number'),
      visible: true,
      orderable: true,
      sort_key: 'attrs.onei3:serial.keyword',
      type: 'text',
      parent: 'attrs',
      url_prefix: 'devices/serial/',
    },
    shared_to: {
      key: 'share:to:',
      label: 'Shared To',
      visible: true,
      orderable: false,
      parent: 'properties',
      type: 'list',
      group: 'sharedTo',
    },
    shared_from: {
      key: 'share:from:',
      label: 'Shared From',
      visible: true,
      orderable: false,
      parent: 'properties',
      type: 'text',
      group: 'sharedFrom',
    },
    attributes: {
      key: 'attributes',
      label: gettext('Attributes'),
      visible: true,
      orderable: false,
      children: {},
    },
  },
  selected: [
    {
      key: 'name',
      label: gettext('Name'),
      orderable: true,
      sort_key: 'name.raw',
      type: 'text',
    },
    {
      key: 'make',
      label: gettext('Make'),
      orderable: true,
      sort_key: 'attrs.make.keyword',
      type: 'text',
      parent: 'attrs',
      group: 'attributes',
    },
    {
      key: 'model',
      label: gettext('Model'),
      orderable: true,
      sort_key: 'attrs.model.keyword',
      type: 'text',
      parent: 'attrs',
      group: 'attributes',
    },
    {
      key: 'communicatedAt',
      label: gettext('Last Communicated'),
      orderable: true,
      sort_key: 'communicatedAt',
      type: 'timeago',
    },
  ],
  columns_order: ['name', 'transferrable', 'make', 'model', 'accountId'],
};

//array of paths to keys need to be saved
export const TableColumnsWhiteListKeys = [[ROOT_TABLE_COLUMNS_STATE, 'selected']];
